import React from "react";
import htmlToImage from "html-to-image";
import {saveAs} from "file-saver";
import { Canvas } from "../comp/Canvas";
import { saveToCache, randomFromList } from "../_global";
import { EmojiDisplayContainer } from "../comp/EmojiDisplayContainer";
import { Icon } from "../comp/Icon";

export class SaveOverlay extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            name: ""
        };

        this.randomName = this.randomName.bind(this);
        this.save = this.save.bind(this);
        this.updateName = this.updateName.bind(this);
        this.download = this.download.bind(this);
    }

    componentDidMount() {
        this.randomName();
    }

    randomName() {
        // pick a random name on-load
        let nameBits = [
            "big", "gaming", "cool", "funny", "epic", "9000", "behe", "hehe", "shut-up-mom", "sans", "cheeky", "demon", "angry",
            "gregzilla", "clown", "funky", "global-warming", "haha", "poop", "uh-oh", "bee", "marmite", "garfield", "thursday", "chicken", "nugget", "minecraft", "gay", "cat", "dead", "pee", "drake", "and", "yeehaw", "space", "cowboy", "lil"
        ];

        this.setState({
            name: randomFromList(nameBits) + '-' + randomFromList(nameBits) + '-' + randomFromList(nameBits)
        });
    }

    save() {
        // save to cache
        saveToCache(this.props.layers, this.state.name);
        this.props.toggle();
    }

    updateName(e) {
        this.setState({ name: e.target.value });
    }

    download() {
        // download
        var el = document.getElementById("fake-canvas");

        this.props.loadStart();

        htmlToImage.toBlob(el)
            .then((blob) => {
                window.saveAs(blob, this.state.name + ".png");
                this.props.loadEnd();
            })
            .catch((error) => {
                console.error(error);
                this.props.loadEnd();
            });
    }


    render() {

        // show/hide
        var classes = "overlay save-overlay",
            body = (
                <div className="">
                    <Canvas open={this.props.open} layers={this.props.layers} side="128" name="save-128" loadStart={this.props.loadStart} loadEnd={this.props.loadEnd} />

                    <Canvas open={this.props.open} layers={this.props.layers} side="64" name="save-64" loadStart={this.props.loadStart} loadEnd={this.props.loadEnd} />

                    <Canvas open={this.props.open} layers={this.props.layers} side="32" name="save-32" loadStart={this.props.loadStart} loadEnd={this.props.loadEnd} />

                    <Canvas open={this.props.open} layers={this.props.layers} side="24" name="save-24" loadStart={this.props.loadStart} loadEnd={this.props.loadEnd} />

                    <Canvas open={this.props.open} layers={this.props.layers} side="16" name="save-16" loadStart={this.props.loadStart} loadEnd={this.props.loadEnd} />
                </div>
            );

        if(!this.props.open) {
            classes += " hidden";
            body = "";
        }


        return (
            <div className={classes}>
                <div className="overlay-inner">
                    <div className="header">Save Emoji</div>

                    <div className="body">
                        <div className="fake-canvas">
                            <EmojiDisplayContainer id="fake-canvas" layers={this.props.layers} />
                        </div>

                        <label>
                            Emoji name 
                            <input 
                                type="text" 
                                placeholder="Enter name here" 
                                value={this.state.name}
                                onChange={this.updateName}
                            />

                            <button onClick={this.randomName}>
                                <Icon type="fa-random" />
                            </button>
                        </label>
                    </div>

                    <div className="footer">
                        <button onClick={this.download}>Download .PNG</button>
                        <button onClick={this.save}>Save Project</button>
                        <button onClick={this.props.toggle}>X</button>
                    </div>
                </div>
            </div>
        );
    }
}


SaveOverlay.defaultProps = {
    open: false
};
